let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h2vch"), load("cEoso"), load("02lUE"), load("i5uoM"), load("a0oMZ")]).then(() => parcelRequire('BkPha'));